// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Gallery_wrapper__23Kab","gallery":"Gallery_gallery__1r2FY"};